import React from 'react';

import { useFullLayoutContext } from '../context';
import { FullLayoutRightSidebar } from '../right-sidebar-pane';

export function RightSidebar({ children, scrollable }: { children?: React.ReactNode; scrollable?: boolean }) {
  const ctx = useFullLayoutContext();
  if (!ctx) return null;

  return (
    <FullLayoutRightSidebar
      ref={ctx.rightSidebarRef as React.Ref<HTMLElement>}
      open={ctx.isRightSidebarOpen}
      scrollable={scrollable}
      className="top-[var(--header-nav-height)]"
    >
      {children}
    </FullLayoutRightSidebar>
  );
}
RightSidebar.displayName = 'FullLayout.RightSidebar';
